import Skeleton from "@ui-kit/feedback/Skeleton/Skeleton.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";

export default function ItemGroupSkeleton(): JSX.Element {
  return (
    <Flex direction="column" gap="md" width="100%">
      <Flex direction="column" gap="md">
        <Flex gap="2xs" direction="column">
          <Skeleton isLoaded={false} width="30%">
            <Text fontSize="sm">Skeleton</Text>
          </Skeleton>
          <Skeleton isLoaded={false} width="40%">
            <Text fontWeight="bold" color="font.dark" fontSize="sm">
              Skeleton
            </Text>
          </Skeleton>
          <Skeleton isLoaded={false} width="35%">
            <Text fontSize="sm">Skeleton</Text>
          </Skeleton>
        </Flex>
        <Flex justifyContent="space-between" direction="row">
          <Skeleton isLoaded={false}>
            <Text fontSize="sm" color="font.dark">
              Skeleton
              <Text as="span" ml="xs">
                Skeleton
              </Text>
            </Text>
          </Skeleton>
          <Skeleton isLoaded={false}>
            <Text fontSize="sm" fontWeight="bold">
              Skeleton
            </Text>
          </Skeleton>
        </Flex>
      </Flex>
    </Flex>
  );
}
